import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./UnitStandardSetup.css";
import SearchView from "../../widgets/SearchView";
import UnitStandardSetupSearchForm from './UnitStandardSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import CardLayout from '../../widgets/Card';
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'SAQAUnitStandardID', numeric: false, disablePadding: true, label: 'SAQA Unit Standard ID' },
    { id: 'SAQAUnitStandardTitle', numeric: false, disablePadding: true, label: 'SAQA Unit Standard Title' }
];

const modelTemplate = [
    { Name: "SAQAUnitStandardID", Value: "" },
    { Name: "SAQAUnitStandardTitle", Value: "" }
];



const utils = new ViewUtils();

class UnitStandardSetupSearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = !utils.isNull(this.props.programmeId) ? [
            { Name: "SAQAUnitStandardID", Value: "" },
            { Name: "SAQAUnitStandardTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "ProgrammeType", Value: this.props.programmeType }
        ]
            :
            [
                { Name: "SAQAUnitStandardID", Value: "" },
                { Name: "SAQAUnitStandardTitle", Value: "" }
            ];

        let model = !utils.isNull(this.props.programmeId) ?
            {
                SAQAUnitStandardID: "",
                SAQAUnitStandardTitle: "",
                ProgrammeID: this.props.programmeId,
                ProgrammeType: this.props.programmeType
            }
            :
            {
                SAQAUnitStandardID: "",
                SAQAUnitStandardTitle: ""
            }

        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }

        if (!utils.isNull(props.personId)) {
            model.PersonID = props.personId;
            this.searchParameters.push({ Name: "PersonID", Value: props.personId })
        }

        this.state = !utils.isNull(this.props.programmeId) ?
            {
                model: model,
                keyUpSwitch: false
            }
            :
            {
                model: model,
                keyUpSwitch: false
            };  

        //TODO: Add url for unit standard removal
        this.deleteUrl = ""

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Unit Standard', icon: "DeleteIcon", disabled: true, visible: this.props.menuPermissionItem.Delete}
                    ]
                }
            ]
        };
    }

    clearSearch(e) {
        this.setState({
            model: {
                SAQAUnitStandardID: "",
                SAQAUnitStandardTitle: "",
                ProgrammeID: this.props.programmeId,
                ProgrammeType: this.props.programmeType
            }
        });
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

  

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/unitStandardSetup/getsearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/unitStandardSetup/RemoveUnitstandard"} useDeletePost={true}
                    entityViewPath='/unitStandardSetup' customMessage={this.props.customMessage} clearPress={(e) => { this.clearSearch(e) }}
                    model={this.state.model} toolbarConfig={this.toolbarConfig} modelClearTemplate={modelTemplate}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="SAQAUnitStandardID" mode={this.props.mode} allowClear={this.props.allowClear}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch} 
                    title='Unit Standards' 
                    selectionCallbackMode={this.props.selectionCallbackMode}
                    promptTitle={"Remove Unit Standard"}
                    promptContent={"Removing the unit standard is a permanent action and the unit standard will not be available going forward. Are you sure you want to remove this unit standard?"}
                >
                    <UnitStandardSetupSearchForm
                        data={this.state.model} 
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>  
            </ViewContainer>    
        );
    }
}


export default withRouter(withMenuPermission(UnitStandardSetupSearch));